import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AgentLocationSummaryGetCollection, AgentLocationSummaryGetCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AgentLocationSummaryGetCollectionResponse, AgentLocationSummaryGetCollectionResponse>) => {
    return response?.data?.agentLocationSummaries
}
const getError = (response?: SWRResponse<AgentLocationSummaryGetCollectionResponse, AgentLocationSummaryGetCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useAgentLocationSummaries = (configuration?: SWRConfiguration<AgentLocationSummaryGetCollectionResponse, AgentLocationSummaryGetCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AgentLocationSummaryGetCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useAgentLocationSummaries;